import type { Path } from "@/router";

export function getEventOverviewPath(slug: string): Path {
  return `/events/${slug}/overview` as Path;
}
